import * as FullScreenActions from 'nav/full-screen/FullScreenActions';
import notifications from 'notifications';
import {OrganizationPermissionRole, TeamPermissionRole} from 'orgs/OrganizationConstants';
import {UserRowInfo} from 'parties/users/UsersForm';
import {TenantScreens} from 'tenants/admin/TenantAdminConstants';
import * as TenantDAO from 'tenants/TenantDAO';

export function openTenantAdminPage(): void {
  FullScreenActions.showScreen(TenantScreens.TENANT_ADMIN_SCREEN);
}

export async function createUsers(
  usersSpreadsheetURL: string | null | undefined,
  userInfos: Array<UserRowInfo> | null,
  organizationInfos: Array<{organizationId: string; role: OrganizationPermissionRole}>,
  teamInfos: Array<{teamId: string; role: TeamPermissionRole}>,
  shouldSendEmails: boolean
): Promise<void> {
  await TenantDAO.createUsers(usersSpreadsheetURL, userInfos, organizationInfos, teamInfos, shouldSendEmails);
  notifications.success('Created users successfully.');
}
